import './App.css';
import React from 'react'
import Amplify, { API } from 'aws-amplify'
import awsconfig from './aws-exports';
import * as queries from './graphql/queries';
import * as mutations from './graphql/mutations';
// import * as subscriptions from './graphql/subscriptions';
import Challenge from './pages/Challenge';
import Response from './pages/Response';
import Welcome from './pages/Welcome';
import Thankyou from './pages/Thankyou';
import ThankyouTest from './pages/ThankyouTest';

Amplify.configure(awsconfig);

class App extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      masterData: {},
      loading: false,
      counter: 0,
      currentState: {},
      mainSequence: [],
      currentResponse: {},
      uuid: null,
      challengePage: true,
      pageCounter: 0,
      order: 1,
      nextToken: undefined,
      score: 0,
      total: 0
    }

    this.updateBackend = this.updateBackend.bind(this);
    this.setResponse = this.setResponse.bind(this);
    this.getUpdatedSeq = this.getUpdatedSeq.bind(this);
    this.getCorrectness = this.getCorrectness.bind(this);
    this.setSequence = this.setSequence.bind(this);
    this.updateNextQuestion = this.updateNextQuestion.bind(this);
    this.startQuiz = this.startQuiz.bind(this);
  }

  componentDidMount() {
    window.history.scrollRestoration = 'manual'
  }

  async fetchMasterData() {
    try {
      const masterData = await API.graphql({ query: queries.listMasterDatas, variables: { filter: { order: { eq: this.state.order } } } });
      // console.log(masterData);
      if (this.state.order === 11) {
        this.setState({
          currentState: masterData.data.listMasterDatas.items,
          masterData: masterData.data.listMasterDatas.items,
          loading: false,
          pageCounter: 3,
        })
      }
      else {
        this.setState({
          currentState: masterData.data.listMasterDatas.items,
          masterData: masterData.data.listMasterDatas.items,
          loading: false,
          pageCounter: 1,
        })
      }

      // console.log(this.state)
    } catch (err) { console.log('error fetching master data') }
  }

  async setSequence() {
    let oldSeq = await this.state.masterData[0].steps.map(seq => seq.seq);
    this.setState({
      mainSequence: oldSeq
    })
  }

  async getUpdatedSeq() {
    return await this.state.currentState[0].steps.map(seq => seq.seq);
  }

  async getCorrectness() {

    let flag = true;
    await this.state.currentState[0].steps.map((seq, index) => {
      if (seq.seq != index + 1) {
        flag = flag && false;
      }
    });

    return flag;
  }

  async updateNextQuestion() {
    this.setState({
      loading: true
    })
    this.fetchMasterData();
  }

  async updateBackend() {

    let stepsInput = await this.getUpdatedSeq();
    let correctInput = await this.getCorrectness();
    if (!this.state.uuid) {
      try {
        const userChoices = {
          response: {
            challengeId: this.state.masterData[0].id,
            steps: stepsInput,
            correct: correctInput
          }
        }
        const newUserChoice = await API.graphql({ query: mutations.createUserChoices, variables: { input: userChoices } });

        let newScore = this.state.score;
        if (correctInput) {
          newScore = this.state.score + 1;
        }

        this.setState({
          uuid: newUserChoice.data.createUserChoices.id,
          pageCounter: 2,
          score: newScore,
          total: this.state.total + 1,
          order: this.state.order + 1
        })
      }
      catch (err) {
        console.log("Error in inserting into database", err);
      }
    }
    else {
      try {
        const userChoices = {
          id: this.state.uuid,
          response: {
            challengeId: this.state.masterData[0].id,
            steps: stepsInput,
            correct: correctInput
          }
        }
        // console.log(userChoices);
        const newUserChoice = await API.graphql({ query: mutations.updateUserChoices, variables: { input: userChoices } });
        // console.log(newUserChoice);
        let newScore = this.state.score;
        if (correctInput) {
          newScore = this.state.score + 1;
        }
        this.setState({
          pageCounter: 2,
          score: newScore,
          total: this.state.total + 1,
          order: this.state.order + 1
        })
      }
      catch (err) {
        console.log("Error in inserting into database");
      }
    }
  }

  setResponse = (newResponse) => {
    this.setState({
      currentState: [newResponse[0]]
    })
    console.log(this.state);
  }

  startQuiz = async () => {
    this.setState({
      loading: true
    })
    await this.fetchMasterData();
  }

  render() {
    if (this.state.loading) {
      return (
        <p className="loader-class"><i className="fa fa-3x fa-spinner fa-spin"></i></p>
      )
    }
    else {
      if (this.state.pageCounter === 0) {
        return (
          <Welcome
            startQuiz={this.startQuiz}
          />
        )
      }
      else if (this.state.pageCounter === 1) {
        // console.log("Challenge: ",this.state.currentState);
        return (
          <>
            <Challenge
              updateBackend={this.updateBackend}
              currentState={this.state.currentState}
              setResponse={this.setResponse}
              order={this.state.order}
            />
          </>
        )
      }
      else if (this.state.pageCounter === 2) {
        return (
          <>
            <Response
              currentState={this.state.currentState}
              updateNextQuestion={this.updateNextQuestion}
              order={this.state.order}
            />
          </>
        )
      }
      else if (this.state.pageCounter === 3) {
        return (
          <Thankyou
            score={this.state.score}
            total={this.state.total}
          />
        )
      }

      else if (this.state.pageCounter === 4) {
        return (
          <ThankyouTest
          // score = {this.state.score}
          // total = {this.state.total}
          />
        )
      }

    }
  }
}

export default App;
